export const LEVELS = ["view", "edit", "administrate"];
const RANK = {
    none: 0,
    view: 1,
    edit: 2,
    administrate: 3,
};
export function isLevel(value) {
    return LEVELS.includes(value);
}
export function isPersonalLevel(value) {
    return value === "none" || isLevel(value);
}
export function reaches(have, need) {
    return RANK[have] >= RANK[need];
}
export function lowerOf(a, b) {
    return RANK[a] <= RANK[b] ? a : b;
}
